import { useEffect, useState } from 'react';
import { Spinner, Table, Row, Col, Button, Form, Modal, InputGroup } from 'react-bootstrap';
import { NavLink } from "react-router-dom";
import { TablePagination, ConfirmDeleteModal } from './Common';
import useAlert from '../../common/useAlert';

const { REACT_APP_BASE_URL: appBaseUrl, REACT_APP_API_BASE_URL: apiBaseUrl, REACT_APP_IMAGE_SIZE_4: imageSize4 } = process.env;

const axios = require('axios').default;
const _ = require('lodash');

const BOOLEAN_TEXT_MAP = {
  true: '是',
  false: '否',
  1: '是',
  0: '否',
}

const WriteModal = ({ handleClose, loadTable, id, filters }) => {
  const [caseNo, setCaseNo] = useState();
  const [name, setName] = useState();
  const [isPrivate, setIsPrivate] = useState(true);
  const [state, setState] = useState();
  const [projectOrder, setProjectOrder] = useState(0);
  const [filterId, setFilterId] = useState(0);
  const { successAlert, errorAlert } = useAlert();

  useEffect(() => {
    if (id) loadDetail(id);
  }, []);

  const submit = async () => {
    if (!name) return;
    if (projectOrder < 0) return errorAlert('排序不能小於 0');

    const url = `${apiBaseUrl}/admin/projects`;
    const data = id
      ? { projects: [{ id, caseNo, name, isPrivate, projectOrder, state, filterId }] }
      : { caseNo, name, isPrivate, projectOrder, state, filterId };
    const method = id ? 'patch' : 'post';
    const successMsg = id ? '編輯作品集成功' : '新增作品集成功';
    axios({ url, data, method })
      .then(response => {
        handleClose();
        loadTable();
        successAlert(successMsg);
      })
  };

  const loadDetail = async (id) => {
    const url = `${apiBaseUrl}/admin/projects/${id}`;
    axios.get(url)
      .then(response => {
        setCaseNo(response.data.caseNo);
        setName(response.data.name);
        setIsPrivate(response.data.isPrivate);
        setProjectOrder(response.data.projectOrder);
        setState(response.data.state);
        setFilterId(response.data.filterId);
      })
  }

  return (
    <Modal show={true} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>{id ? '編輯' : '新增'}作品集</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group className="mb-3" controlId="name">
            <Form.Label className="required">標題</Form.Label>
            <Form.Control
              required
              type="text"
              placeholder=""
              value={name}
              onChange={({ target: { value } }) => setName(value)}
            />
          </Form.Group>
          <Form.Group className="mb-3" controlId="caseNo">
            <Form.Label>案件編號</Form.Label>
            <Form.Control
              type="text"
              value={caseNo}
              onChange={({ target: { value } }) => setCaseNo(value)}
            />
          </Form.Group>
          <Form.Group className="mb-3" controlId="process">
            <Form.Label>相簿分類</Form.Label>
            <Form.Control
              as="select"
              value={filterId}
              onChange={({ target: { value } }) => setFilterId(value)}
            >
              <option value="">請選擇</option>
              {filters.map(({ id, name }) => (
                <option key={id} value={id}>{name}</option>
              ))}
            </Form.Control>
          </Form.Group>
          <Row>
            <Col className="mb-3" sm={3}>
              <Form.Label className="required">是否上鎖</Form.Label>
              <InputGroup className="mb-3">
                <Button
                  variant="outline-primary"
                  active={isPrivate}
                  onClick={() => setIsPrivate(true)}
                >是</Button>
                <Button
                  variant="outline-primary"
                  active={!isPrivate}
                  onClick={() => setIsPrivate(false)}
                >否</Button>
              </InputGroup>
            </Col>
            {id &&
              <Col className="mb-3" sm={3}>
                <Form.Label>是否顯示</Form.Label>
                <InputGroup className="mb-3">
                  <Button
                    variant="outline-primary"
                    active={state}
                    onClick={() => setState(1)}
                  >是</Button>
                  <Button
                    variant="outline-primary"
                    active={!state}
                    onClick={() => setState(0)}
                  >否</Button>
                </InputGroup>
              </Col>
            }
          </Row>
          <Form.Group className="mb-3" controlId="order">
              <Form.Label>排序</Form.Label>
              <Form.Control
                type="number"
                value={projectOrder}
                onChange={({ target: { value } }) => setProjectOrder(value)}
              />
            </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={submit}>
          {id ? '編輯' : '新增'}作品集
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

const TableFilter = ({ loadTable, setSize }) => {
  const [name, setName] = useState();
  const [isPrivate, setIsPrivate] = useState();

  const search = async () => {
    loadTable({ name, isPrivate });
  }

  return (
    <Row className="mb-3">
      <Form.Group as={Col} className="mb-3" controlId="name">
        <Form.Label>標題</Form.Label>
        <Form.Control
          type="text"
          placeholder=""
          onChange={({ target: { value } }) => setName(value)}
        />
      </Form.Group>
      <Form.Group as={Col} className="mb-3" controlId="isPrivate">
        <Form.Label>是否上鎖</Form.Label>
        <Form.Control
          as="select"
          placeholder=""
          onChange={({ target: { value } }) => setIsPrivate(value)}
        >
          <option value="">全部</option>
          <option value={true}>是</option>
          <option value={false}>否</option>
        </Form.Control>
      </Form.Group>
      <Form.Group as={Col} className="mb-3" controlId="size">
        <Form.Label>查詢筆數</Form.Label>
        <Form.Control
          as="select"
          onChange={({ target: { value } }) => setSize(value)}
        >
          <option value={20}>20</option>
          <option value={10}>10</option>
          <option value={5}>5</option>
        </Form.Control>
      </Form.Group>
      <Col>
        <Button variant="primary" className="custom-btn" as={Col} onClick={search}>查詢</Button>
      </Col>
    </Row>
  )
}

const DataTable = ({ loading, list, setModalShow, setId, loadTable, filterMap }) => {
  const [deletedIds, setDeletedIds] = useState([]);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [updatedProject, setUpdatedProject] = useState({});
  const { successAlert, errorAlert } = useAlert();

  const handleDelete = async () => {
    if (deletedIds.length === 0) return;

    const url = `${apiBaseUrl}/admin/projects`;
    const data = { ids: deletedIds };
    axios.delete(url, { data })
      .then(response => {
        loadTable();
        setDeletedIds([]);
        successAlert('批次刪除成功');
      })
    setShowDeleteConfirm(false);
  }

  const handleUpdate = async () => {
    const projects = _.map(updatedProject, (payload, id) => ({ id, ...payload }));
    if (_.some(projects, ({ projectOrder }) => projectOrder < 0)) {
      errorAlert('排序不能小於 0');
      return;
    }

    const url = `${apiBaseUrl}/admin/projects`;
    axios.patch(url, { projects })
      .then(response => {
        loadTable();
        setUpdatedProject({});
        successAlert('批次修改成功');
      })
  }

  return <>
    <Table striped bordered hover>
      <thead>
        <tr>
          <th>id</th>
          <th>標題</th>
          <th>案件編號</th>
          <th>封面</th>
          <th>是否上鎖</th>
          <th>是否顯示</th>
          <th>相簿分類</th>
          <th>
            排序 &nbsp;&nbsp;&nbsp;
            <Button
                size="sm"
                variant="primary"
                onClick={() => handleUpdate(true)}
                disabled={_.isEmpty(updatedProject)}
              >更新</Button>
            </th>
          <th>檢視相片</th>
          <th>編輯</th>
          <th>
            <Button
              size="sm"
              variant="danger"
              onClick={() => setShowDeleteConfirm(true)}
              disabled={deletedIds.length === 0}
            >刪除</Button>
          </th>
        </tr>
      </thead>
      <tbody>
        {loading
          ? <Spinner animation="border" />
          : list?.map(({ id, caseNo, name, isPrivate, projectOrder, state, filterId, coverImage }) => (
            <tr key={id}>
              <td>{id}</td>
              <td>{name}</td>
              <td>{caseNo}</td>
              <td>{coverImage && <img src={`${appBaseUrl}${coverImage[imageSize4]}`} width="200" alt=""/>}</td>
              <td>{BOOLEAN_TEXT_MAP[isPrivate]}</td>
              <td>{BOOLEAN_TEXT_MAP[state]}</td>
              <td>{filterMap[filterId]}</td>
              <td>
                <Form.Control
                  className="order-input"
                  type="number"
                  value={updatedProject[id]?.projectOrder === undefined ? projectOrder : updatedProject[id]?.projectOrder}
                  onChange={(evt) => {setUpdatedProject({
                    ...updatedProject,
                    [id]: { ...updatedProject[id], projectOrder: evt.target.value } }
                  )}}
                />
              </td>
              <td>
                <NavLink to={`/admin/projects/${id}/images`}>
                  <Button size="sm" variant="outline-primary">檢視相片</Button>
                </NavLink>
              </td>
              <td >
                <Button
                  size="sm"
                  variant="outline-primary"
                  onClick={() => {setModalShow(true);setId(id)}}
                >編輯</Button>
              </td>
              <td>
                <Form.Check
                  type="checkbox"
                  label=""
                  onChange={(evt) => {
                    if (evt.target.checked)
                      setDeletedIds([...deletedIds, id]);
                    else
                      setDeletedIds(deletedIds.filter(i => i !== id));
                  }}
                />
              </td>
            </tr>
          ))}
      </tbody>
    </Table>
    <ConfirmDeleteModal {...{
      show: showDeleteConfirm,
      handleClose: () => setShowDeleteConfirm(false),
      dataName: '進度',
      deletedIds,
      handleDelete,
    }} />
  </>
}

const Project = () => {
  const [loading, setLoading] = useState(true);
  const [list, setList] = useState([]);
  const [paginationInfo, setPaginationInfo] = useState();
  const [size, setSize] = useState(20);
  const [modalShow, setModalShow] = useState(false);
  const [id, setId] = useState();
  const [filters, setFilters] = useState([]);
  const filterMap = _.chain(filters).keyBy('id').mapValues('name').value();

  useEffect(() => {
    loadTable();
    loadFilters();
  }, []);

  const loadTable = async ({ page, name, isPrivate } = {}) => {
    setLoading(true);
    let url = `${apiBaseUrl}/admin/projects?page=${page || 1}&size=${size}`;
    if (isPrivate) url += `&isPrivate=${isPrivate}`;
    if (name) url += `&name=${name}`;

    axios.get(url)
      .then(response => {
        setList(response?.data?.list);
        setPaginationInfo(_.omit(response?.data, 'list'));
        setLoading(false);
      })
  };

  const loadFilters = async () => {
    const url = `${apiBaseUrl}/projects/filters`;
    axios.get(url)
      .then(response => setFilters(response?.data?.filters))
  };

  return <>
    <Button variant="primary" className="new-btn" onClick={() => setModalShow(true)}>新增作品集</Button>{' '}
    <h1 className="title">作品集</h1>
    {modalShow &&
      <WriteModal
        id={id}
        handleClose={() => {setModalShow(false); setId(null);}}
        loadTable={() => loadTable()}
        filters={filters}
      />
    }
    <TableFilter {...{ setLoading, setList, setSize, loadTable }} />
    <DataTable {...{ loading, list, setId, setModalShow, loadTable, filterMap }}/>
    <TablePagination {...{ paginationInfo, loadTable, loading }}/>
  </>;
};

export default Project;
